export default class T {
  //-----------------Login screen----------------//
  static INSTANT = "Instant";
  static LOGIN = "Login";
  static LOGO = "Logo";
  static RTR = "RTR";
  static WITH_CASHD = "With Cashd";
  static LETTER = "Letter";
  static ENTER_YOUR_EMAIL = "Enter your email";
  static SEND_OTP = "Send OTP";
  static LOGIN_WITH_PASSWORD = "Login with password";
  /*--------------TOAST MESSAGE IN LOGIN----------------*/
  static EMAIL_IS_REQUIRED = "Email is required";
  static WARNING = "Warning";
  static CODE_SENT_SUCCESSFULLY = "Code sent successfully.";
  static PLEASE_CHECK_YOUR_EMAIL_AND_TRY_AGAIN = "Please check your email and try again.";
  static ERROR = "Error";
  static MIA_BIRTHDAY_COMING_UP_BEFORE_PAYDAY = "Mia’s birthday coming up before payday?";
  static EMAIL_IS_INVALID = "Email is invalid";
  /*-------------LOGIN WITH PASSWORD TOAST MESSAGES---------------*/
  static YOUR_COMPANY_HAS_BEEN_DISCONNECTED_FROM_CASHD = "Your company has been disconnected from CashD, you no longer have access. For any queries, please contact your employer / supervisor or send an email to support@cashd.com.au.";
  static YOU_HAVE_BEEN_DISCONNECTED_FROM_CASHD = "You have been disconnected from CashD, you no longer have access. For any queries, please contact your employer / supervisor or send an email to support@cashd.com.au.";
  static ERROR_FROM_SERVER = "Error from server";
  static EMAIL_OR_PASSWORD_INCORRECT = "Email or password incorrect. Try again!";
  /*---------------LOGIN WITH PASSWORD--------------------------*/
  static CANT_WAIT = "can’t wait";
  static FOR_PAYDAY = "for payday";
  static TO_TAKE_MAX_TO_VET = "to take Max to the vet?";
  static PASSWORD = "Password";
  static SIGN_IN = "Sign in";
  static LOGIN_WITH_OTP = "Login with OTP";
  /*-----------------------OTP SCREEN TOAST MESSAGES----------------------------*/
  static YOUR_CASHD_ACCOUNT_IS_NOT_LINKED_TO_ANY_PAYROLL = "Your CashD account is not linked to any payroll system. Please register again or contact support for assistance support@cashd.com.au.";
  static YOUR_CODE_HAS_EXPIRED = "Your Code has expired";
  /*-----------------------OTP SCREEN----------------------------*/
  static CANT_FUEL = "Can't Fuel";
  static UP_WAITING = "Up Waiting";
  static FOR_PAYDAY_? = "For Payday ?";
  static ENTER_OTP = "Enter OTP";
  static PLEASE_ENTER_THE_6_DIGIT_CODE_SENT_TO_YOUR_EMAIL_AT = "Please enter the 6-digit code sent to your email at";
  static DIDNT_RECEIVE_THE_CODE = "Didn't receive the code?";
  static RESEND_IN = "Resend in:";
  static RESEND = "Resend";
  /*-----------------TERMS AND CONDITIONS TOAST MESSAGES---------------------------------*/
  static YOU_MUST_ACCEPT_TERM_AND_CONDITION = "You must accept the term and conditions.";
  /*-----------------TERMS AND CONDITIONS---------------------------------*/
  static AT_YOUR_FINGERTIPS = "at your fingertips";
  static WELCOME = "Welcome";
  static I_AGREE_TO_THE_TERMS_CONDTIONS = "I agree to the terms & conditions";
  static ACCEPT = "Accept";
  static VIEW_CASHD_TERMS_CONDITION_HERE = "View CashD terms & conditions here";


  /* ASTUTE PayRoll Feature */
  static SWITCH_PAYROLL = "Switch Payroll";
  static CURRENT_PAYROLL = "Current Payroll";
  static LAST_PAYROLL = "Last Payroll";


  // DashboardLayout Sidebar
  static DASHBOARD = "Dashboard"
  static TRANSACTIONS = "Transactions"
  static WITHDRAW_MONEY = "Withdraw Money"
  static SUMMARY = "Summary"
  static SUPPORT = "Support"
  static RECURRING_WITHDRAWAL = "Recurring Withdrawal"
  static PROFILE = "Profile"
  static LOGOUT = "Logout"
  static RECURRING_WITHDRAWAL_DESCRIPTION = "Configure the amount and schedule for automatic withdrawals."
  static NO_RECURRING_WITHDRAWAL_SET = "No Recurring Withdrawal Set"
  static AUTOMATE_YOUR_SALARY_WITHDRAWALS_BY_SETTING_UP_A_RECURRING_SCHEDULE = "Automate your salary withdrawals by setting up a recurring schedule. Save time every pay cycle."
  static SETUP_NOW = "Setup Now"
  static NEXT_WITHDRAWAL = "Next Withdrawal"
  static NEXT_WITHDRAWAL_DATE = "Withdrawal Date"
  static WITHDRAWAL_AMOUNT = "Withdrawal Amount"
  static FEES = "Fees"
  static PAY_PERIOD = "Pay Period"
  static ENABLED = "Enabled"
  static DISABLED = "Disabled"
  static SAVE = "Save"
  static AMOUNT = "Amount"
  static WITHDRAWAL_FREQUENCY = "Withdrawal Frequency"
  static WITHDRAWAL_DAY = "Withdrawal Day"
  static RECURRING_WITHDRAWAL_CANNOT_BE_ENABLED_ON_THE_LAST_DAY_OF_THE_PAY_PERIOD_PLEASE_TRY_AGAIN_AFTER_THE_NEXT_PAY_CYCLE = "Recurring withdrawal cannot be enabled on the last day of the pay period. Please try again after the next pay cycle."
  static YOU_CANNOT_CHANGE_RECURRING_WITHDRAWAL_ON_THE_LAST_DAY_OF_THE_PAY_PERIOD_PLEASE_TRY_AGAIN_AFTER_THE_NEXT_PAY_CYCLE = "You cannot change recurring withdrawal on the last day of the pay period. Please try again after the next pay cycle"
  static SETUP_RECURRING_PAYMENT = "Setup Recurring Payment"
  static PAYMENT_SETTINGS = "Payment Settings"
  static ACCRUED_WAGE = "Accrued Wage"
  static VIEW = "View"
  static RECENT_TRANSACTIONS = "Recent Transactions"
  static CURRENT_WITHDRAWAL = "Current Withdrawal"
  static TOTAL_WITHDRAWALS = "Total Withdrawals"
  static LAST_6_MONTHS = "Last 6 Months"



  // Support Screen
  static NEED_HELP = "Need Help?"
  static OTHER_WAYS_TO_REACH_US = "Other Ways to Reach Us"
  static OUR_SUPPORT_TEAM_IS_READY_TO_ASSIST_YOU_WITH_ANY_QUESTIONS_ABOUT_YOUR_SALARY_WITHDRAWALS_ACCOUNT_SETTINGS_OR_TECHNICAL_ISSUES = "Our support team is ready to assist you with any questions about your salary withdrawals, account settings, or technical issues."
  static SUPPORT_EMAIL = "support@cashd.com.au"
  static SUPPORT_HOURS = "Support hours: Monday to Friday, 9 AM to 6 PM"
  static QUICK_HELP = "Quick Help"
  static HOW_DO_WITHDRAWALS_WORK = "How do withdrawals work?"
  static WHEN_WILL_I_RECEIVE_MY_MONEY = "When will I receive my money?"
  static ARE_THERE_ANY_FEES = "Are there any fees?"
  static YOU_CAN_WITHDRAW_YOUR_EARNED_SALARY_ANYTIME_DURING_YOUR_BILLING_CYCLE = "You can withdraw your earned salary anytime during your billing cycle."
  static WITHDRAWALS_ARE_PROCESSED_INSTANTLY_TO_YOUR_REGISTERED_BANK_ACCOUNT = "Withdrawals are processed instantly to your registered bank account."
  static FEES_MAY_APPLY_AS_DETERMINED_BY_YOUR_EMPLOYER_CHECK_WITH_HR_FOR_DETAILS = "Fees may apply as determined by your employer. Check with HR for details."
  static CONTACT_SUPPORT = "Contact Support"

  // Payment Settings
  static SET_PRIMARY_ACCOUNT = "Set Primary Account"
  static SELECT_THE_ACCOUNT_THAT_WILL_RECEIVE_YOUR_WITHDRAWALS = "Select the account that will receive your withdrawals."
  static PLEASE_CONTACT_YOUR_RESPECTIVE_HR_NO_BANK_ACCOUNT_IS_CONNECTED = "Please contact your respective HR. No bank account is connected"
  static BANK_BSB = "Bank BSB"

  // User Profile Screen
  static USER_PROFILE = "User Profile"
  static COMPANY_DETAILS = "Company Details"
  static PAYROLL_DETAILS = "Payroll Details"
  static FULL_NAME = "Full Name"
  static EMAIL_ADDRESS = "Email Address"
  static PHONE_NUMBER = "Phone Number"
  static COUNTRY = "Country"
  static ADDRESS = "Address"
  static COMPANY_NAME = "Company Name"
  static ABN_NUMBER = "ABN number"
  static IRD_NUMBER = "IRD number"
  static PAYROLL_CYCLE = "Payroll Cycle"
  static EMPLOYMENT_TYPE = "Employment type"
  static PAYROLL_SYSTEM = "Payroll System"
  static NO_MORE_PAY_PERIODS_TO_SHOW = "No more pay periods to show."
  // Balance Screen
  static AVAILABLE_BALANCE = "Available balance"
  static AVAILABLE_BALANCE_OF_LAST_PAYROLL = "Available balance of Last Payroll"
  static WITHDRAWN_THIS_CYCLE = "Withdrawn this cycle"
  static WITHDRAWN_LAST_CYCLE = "Withdrawn last cycle"
  static WITHDRAWALS_LOCKED = "Withdrawals Locked"
  static VIEW_SUMMARY = "View Summary"
  static AVAILABLE_WITHDRAWAL_AMOUNT = "Available Withdrawal Amount"
  static QUICK_SELECT = "Quick Select"
  static CONFIRM_WITHDRAWAL = "Confirm Withdrawal"
  static BY_CONFIRMING_YOU_AGREE_TO_WITHDRAW = "By confirming, you agree to withdraw"
  static FROM_YOUR_AVAILABLE_BALANCE_THIS_AMOUNT_WILL_BE_DEPOSITED_TO_YOUR_PRIMARY_BANK_ACCOUNT = "from your available balance. This amount will be deposited to your primary bank account."
  static ACCOUNT_NUMBER = "Account number"
  static TRANSFER_FEE = "Transfer fee"
  static PAYEE = "Payee"
  static PAYMENT_INFORMATION_IS_AUTOMATICALLY_UPDATED_BASED_ON_YOUR_COMPANY_S_HR_SYSTEMS = "Payment information is automatically updated based on your company's HR systems"
  static TO_UPDATE_YOUR_PERSONAL_INFORMATION_PLEASE_CONTACT_YOUR_HR_DEPARTMENT = "To update your personal information, please contact your HR department"
  static BACK = "Back"
  static THE_PAY_CYCLE_IS_CURRENTLY_UNAVAILABLE_PLEASE_TRY_AGAIN_LATER = "The pay cycle is currently unavailable. Please try again later."
  static AUTO = "Auto"
  static WITHDRAWAL_TYPE = "Withdrawal Type"
  static TOTAL_DEDUCTION = "Total deduction"
  static BANK_BSB_NUMBER = "Bank BSB#"
  static TRANSACTION_RECEIPT = "Transaction Receipt"
  static AMOUNT_RETURNED = "Amount returned"
  static AMOUNT_TRANSFERRED = "Amount transferred"
  static WITHDRAWAL_SUCCESSFUL = "Withdrawal Successful"
}
